import Vue from 'vue';
import AppActiveCampaign from '@/plugins/graphql/queries/v2/survey/raffle-campaign.gql';
export default Vue.extend({
    apollo: {
        appActiveCampaign: {
            query: AppActiveCampaign,
            variables() {
                return {
                    appUuid: this.appUuid,
                };
            },
            update(data) {
                return data.appActiveCampaign;
            },
        },
    },
    props: {
        appUuid: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            appActiveCampaign: null,
        };
    },
    computed: {
        loading() {
            return this.$apollo.queries.appActiveCampaign.loading;
        },
    },
    watch: {
        appActiveCampaign(val) {
            if (val) {
                this.$emit('setActiveCampaignUuid', val.uuid);
            }
        },
    },
    render() {
        if (this.$scopedSlots.default) {
            return this.$scopedSlots.default({
                appActiveCampaign: this.appActiveCampaign,
            });
        }
    },
});
